import React from "react";
import { OptionsManagement } from "@components/Options";

export default function OptionsIndex() {
  return <OptionsManagement />;
}
